import { Globe } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useUserLocale, LOCALE_LABELS, type Locale } from "@/lib/i18n/useUserLocale";
import { toast } from "sonner";

const LocalePanel = () => {
  const { locale, autoTranslate, loading, update } = useUserLocale();

  if (loading) return <p className="text-sm text-muted-foreground">Loading…</p>;

  const setLocale = async (v: string) => {
    const { error } = await update({ locale: v as Locale });
    if (error) toast.error(error);
    else toast.success("Language updated.");
  };

  const setAuto = async (v: boolean) => {
    const { error } = await update({ auto_translate_incoming: v });
    if (error) toast.error(error);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-start gap-3">
        <Globe className="h-5 w-5 mt-0.5 text-muted-foreground" />
        <div className="flex-1">
          <p className="text-sm">
            Choose your reading language. RAELA will translate incoming messages on your request.
          </p>
        </div>
      </div>

      <div className="rounded-xl border border-border bg-card p-4 space-y-4">
        <div className="space-y-1.5">
          <Label className="text-sm">Language</Label>
          <Select value={locale} onValueChange={setLocale}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              {(Object.keys(LOCALE_LABELS) as Locale[]).map((l) => (
                <SelectItem key={l} value={l}>{LOCALE_LABELS[l]}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex items-start justify-between gap-4 border-t border-border pt-4">
          <div>
            <Label className="text-sm">Auto-translate incoming messages</Label>
            <p className="mt-0.5 text-xs text-muted-foreground">
              Show messages in your language with original text below.
            </p>
          </div>
          <Switch checked={autoTranslate} onCheckedChange={setAuto} />
        </div>
      </div>
    </div>
  );
};

export default LocalePanel;
